<template>
  <div
    style="position:sticky;border: 1px solid #0000001A"
    :style="{ 'border-radius': `0 0 0 0`, 'font-family': GlobalFont, 
        'background-color': isSecundary ? BGColorSecundary : BGColor, 
        'color': isSecundary ? ColorSecundary : Color,
        'background-image': ((isSecundary && withGradientSubmenu) || (!isSecundary && withGradient)) ? 'linear-gradient(to top, rgba(128, 128, 128, 0.0), rgba(0, 0, 0, 0.2))' : ''
      }"
  >
    <v-layout
      wrap
      align-center
      justify-center
      style="position: relative; height: 100%;width: 100%;"
    >
      <v-flex xs12>
        <div
          class="text-center"
          :style="{ 
            'padding': !isSecundary ? '20px 10px 20px 10px !important' : '10px 40px 10px 40px !important',
            'font-family':  isSecundary ? FontSecundary : Font,
            'font-size': isSecundary ? `${FontSizeSecundary}px` : `${FontSize}px`,
            }"
        >          
          <!-- {{ getName(locale) }} -->
          {{ isSecundary 
            ? (TextFormatSecundary === 1 ? getName(locale).toUpperCase() : TextFormatSecundary === 2 ? getName(locale).toLowerCase() : getName(locale)) 
            : (TextFormat === 1 ? getName(locale).toUpperCase() : TextFormat === 2 ? getName(locale).toLowerCase() : getName(locale))
          }}
        </div>
      </v-flex>
    </v-layout>
    <!-- <v-layout
      wrap
      align-center
      justify-center
      style="position: relative; height: 100%; width: 100%;"
    >
      <v-flex
        xs4
      >
      </v-flex>
      <v-flex xs4 />
      <v-flex xs4>
        <div class="text-right">
          <v-btn class="mnuEdit" fab dark small :color="editTMP.isSecundary ? 'purple' : 'secundary'"
          style="margin: 15px;"
            @click.stop="onEdit(menu)"
          >
            <v-icon dark>mdi-file-document-box-plus-outline</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout> -->
      <!-- <v-icon style="margin-right: 10px;"></v-icon>
      <v-spacer />
      <v-toolbar-title>{{ editTMP.Name.es }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        class="mx-2" fab dark small 
        :color="enterpriseColor"
        @click.stop="handleAdd"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn> -->
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  export default {
    props: {
      name: {
        type: Object,
        require: true
      },
      isSecundary: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      ...mapState('app',['locale', 'withLine', 'withGradient', 'withGradientSubmenu','BGColor', 'Color', 'BGColorSecundary', 'ColorSecundary', 'GlobalFont', 'FontSecundary', 'FontSizeSecundary', 'Font', 'FontSize', 'TextFormat', 'TextFormatSecundary']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseName () {
        return this.$store.state.app.enterpriseName
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    methods: {
      getName(aux) {
        return utils.getTranslation(this.name, aux)
      },
      getColor () {
        if (this.isSecundary) {
          if (this.ColorSecundary && this.ColorSecundary.length >= 7) {
            return this.ColorSecundary.substring(0, 7).concat('4d')
          }
          return this.ColorSecundary
        } else {
          if (this.Color && this.Color.length >= 7) {
            return this.Color.substring(0, 7).concat('4d')
          }
          return this.Color
        }
      },
    }
  }
</script>
<style lang="scss">
  .mnuEdit {
    min-height: 20px;
    height: 25px !important;
    width: 25px !important;
  }
</style>
